import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { IBehaelterstandortKorrektur } from '../_interfaces/behaelterstandort-korrektur';
//import { IChoiceList } from '../_interfaces/_choice-list';
import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable()
export class BehaelterstandortKorrekturService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'id', type: 'int'},
    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
    {name: 'status', type: 'string'},
    {name: 'kundennummer', type: 'string'},
    {name: 'behaelternummer', type: 'string'},
    {name: 'name_1', type: 'string'},
    {name: 'name_2', type: 'string'},
    {name: 'strasse', type: 'string'},
    {name: 'plz', type: 'string'},
    {name: 'ort', type: 'string'},
    {name: 'ortzusatz', type: 'string'},
    {name: 'telefon', type: 'string'},
    {name: 'telefonGeschaeftlich', type: 'string'},
    {name: 'telefonPrivat', type: 'string'},
    {name: 'telefonMobil', type: 'string'},
    {name: 'telefon', type: 'string'},
    {name: 'telefon', type: 'string'},
    {name: 'geodaten_Breite', type: 'double'},
    {name: 'geodaten_Laenge', type: 'double'},
    {name: 'eMail', type: 'string'},
    {name: 'bemerkung', type: 'string'}
  ];
    
  getBehaelterstandortKorrekturenCollection(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ stammdatenKorrekturen: IBehaelterstandortKorrektur[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'behaelterstandortkorrekturen?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          return { stammdatenKorrekturen: <IBehaelterstandortKorrektur[]>response.body, pagination: /*<IPagination>JSON.parse(response.headers.get('x-pagination'))*/this.getDummyPagination((<any[]>response.body).length) };
        }), catchError(this.handleError))
  }

  getBehaelterstandortKorrektur(id: number): Observable<IBehaelterstandortKorrektur> {

    if (id === 0) {
      return Observable.create((observer: any) => {
        observer.next(this.initializeBehaelterstandortKorrektur());
        observer.complete();
      })
    }

    return this.httpClient.get<IBehaelterstandortKorrektur>(this.apiBaseUrl + 'behaelterstandortkorrekturen?id=' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => 
        //response
        {
               console.log("BehaelterstandortKorrekturService.getKopfdaten() response: ", response)
               return response[0];
        }
      ), catchError(this.handleError));
  }

  saveBehaelterstandortKorrektur(stammdatenKorrektur: IBehaelterstandortKorrektur): Observable<IBehaelterstandortKorrektur> {
    // DateTimeOffset-Fix
    let itemToSave = cloneDeep(stammdatenKorrektur); // clonen, um sicherzustellen, dass das Original-Objekt nicht ver�ndert wird, evtl. passiert nach dem Save noch etwas damit ?
    //console.log("BehaelterstandortKorrekturService.saveSingularCapitalized#() itemToSave before DateTimeOffset-Fix:", itemToSave);
    this.propertyTypes.filter(f => f.type.toLowerCase() == 'datetimeoffset').forEach(propertyType => {
      if (itemToSave[propertyType.name] != null) {
        itemToSave[propertyType.name] = moment(itemToSave[propertyType.name]).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // alle datetimeoffset-felder entspr. formatieren, dass in der API auch der Offset ankommt!
      }
    });
    //console.log("BehaelterstandortKorrekturService.saveSingularCapitalized#() itemToSave after DateTimeOffset-Fix:", itemToSave);

    if (stammdatenKorrektur.id === 0) {
      return this.createBehaelterstandortKorrektur(/*stammdatenKorrektur*/itemToSave);
    }

    return this.updateBehaelterstandortKorrektur(/*stammdatenKorrektur*/itemToSave)

  }

  updateBehaelterstandortKorrektur(stammdatenKorrektur: IBehaelterstandortKorrektur): Observable<IBehaelterstandortKorrektur> {

    return this.httpClient.put<IBehaelterstandortKorrektur>(this.apiBaseUrl + 'behaelterstandortkorrekturen' /*+ stammdatenKorrektur.id*/, stammdatenKorrektur, { headers: httpOptions, observe: 'body', withCredentials: true })
    .pipe(catchError(this.handleError))

  }

  deleteBehaelterstandortKorrektur(id: number) {
    return this.httpClient.delete(this.apiBaseUrl + 'behaelterstandortkorrekturen?id=' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(
        catchError(this.handleError)
      )
  }

  createBehaelterstandortKorrektur(stammdatenKorrektur: IBehaelterstandortKorrektur): Observable<IBehaelterstandortKorrektur> {
    return this.httpClient.post<IBehaelterstandortKorrektur>(this.apiBaseUrl + 'behaelterstandortkorrekturen', stammdatenKorrektur, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError))
  }

  initializeBehaelterstandortKorrektur(): IBehaelterstandortKorrektur {
    return {
      id: 0,
      createdBy: '',
      created: /*''*/'0001-01-01T00:00:00.000Z', // fix
      modifiedBy: '',
      modified: /*''*/'0001-01-01T00:00:00.000Z', // fix
      rowVersion: '',
      status: '',
      kundennummer: '',
      behaelternummer: '',
      name_1: '',
      name_2: '',
      strasse: '',
      plz: '',
      ort: '',
      ortzusatz: '',
      telefon: '',
      telefonGeschaeftlich: '',
      telefonPrivat: '',
      telefonMobil: '',
      eMail: '',
      geodaten_Breite: null,
      geodaten_Laenge: null,
      bemerkung: ''
    };
  }


}
